/* 🤖 this file was generated by svg-to-ts */
export const emperorIconVoteStar1: {
  name: 'vote_star_1';
  data: string;
} = {
  name: 'vote_star_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M21.924 8.61c-.16-.38-.52-.62-.93-.62h-5.382L12.888 2.54c-.34-.677-1.45-.677-1.79 0L8.36 7.99H2.97c-.41 0-.77.24-.93.61 -.16.37-.07.8.21 1.09l4.584 4.584L5 20.704c-.12.4.03.83.37 1.08 .34.24.79.25 1.14.02l5.446-3.63 5.445 3.63c.16.11.36.16.55.16 .2 0 .41-.07.59-.2 .33-.25.48-.68.37-1.09l-1.84-6.44 4.584-4.584c.28-.29.37-.72.21-1.09Z"/></svg>`,
};
